import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FeatureFlagService } from '@rubii/frontend-common';
import { HttpException } from '@rubii/share/src/classes';
import { ConfigService } from '../../../../app/services/config.service';
import { ClientService } from '../../../services/client.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';

@Component({
  selector: 'app-yahoojp',
  templateUrl: './yahoojp.component.html',
  styleUrls: ['./yahoojp.component.scss']
})
export class YahoojpComponent extends BaseDatasourceComponent implements OnInit {
  baseAccounts: any[] = [];
  selectedBaseAccountIds: FormControl;
  loading = false;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, baseAccounts?: any[] }, 
    private client: ClientService, 
    private config: ConfigService, 
    private feature: FeatureFlagService,
    private snackBar: MatSnackBar, 
    private dialogRef: MatDialogRef<DatasourceConnectionComponent>
  ) {
    super();
  }

  ngOnInit() {
    this.selectedBaseAccountIds = new FormControl([], [Validators.required]);
    if (this.data.baseAccounts) {
      this.baseAccounts = this.data.baseAccounts;
      this.loading = false;
    }
  }

  connect() {
    this.loading = true;
    this.client.account.saveYahoojpConfig(this.selectedBaseAccountIds.value)
      .then(() => {
        this.loading = false;
        this.openSnackBar(this.snackBar, 'Yahoo! Japan Ads connected successfully.', 'closed'); 
        this.dialogRef.close({dataSourceId: this.data.dataSourceId});
      })
      .catch(e => {
        this.loading = false;
        this.openSnackBarWarning(this.snackBar, (e as HttpException).message, 'closed');
      });
  }
}